<h2 mat-dialog-title>Crear Usuario Administrador</h2>

<mat-dialog-content>
    <div class="alert alert-info mb-3">
        <i class="fa-solid fa-info-circle me-2"></i>
        Este formulario permite crear usuarios con rol de administrador. El usuario se creará con acceso completo al sistema.
    </div>
    
    <div *ngIf="isLoading; else formContent" class="text-center my-3">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2">Procesando solicitud...</p>
    </div>
    
    <ng-template #formContent>
        <form [formGroup]="form" class="mt-3">
            <div class="row">
                <!-- Columna izquierda con datos principales -->
                <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                    <h5 class="mt-2 mb-2">Usuario</h5>
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Correo electrónico</label>
                                <div class="input-group">
                                    <input type="email" class="form-control" formControlName="email">
                                    <span class="input-group-text">
                                        <i *ngIf="form.get('email')?.valid && form.get('email')?.value" class="fa-solid fa-circle-check text-success"></i>
                                        <i *ngIf="form.get('email')?.invalid && form.get('email')?.touched" class="fa-solid fa-circle-xmark text-danger"></i>
                                    </span>
                                </div>
                                <app-form-errors [controlName]="form.controls['email']"></app-form-errors>
                                <small class="text-muted">Este será también el nombre de usuario</small>
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label>Teléfono</label>
                                <input type="text" class="form-control" formControlName="phoneNumber">
                                <app-form-errors [controlName]="form.controls['phoneNumber']"></app-form-errors>
                            </div>
                        </div>
                    </div>
                    
                    <h5 class="mt-2 mb-2">Datos generales</h5>
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Tipo de Identificación</label>
                                <div>
                                    <app-dropdown [options]="typeIdentList" formControlName="typeIdentificationId" (selectionChange)="updateDocumentMask()"></app-dropdown>
                                </div>
                                <app-form-errors [controlName]="form.controls['typeIdentificationId']"></app-form-errors>
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Número de Identificación</label>
                                <div>
                                    <input type="text" class="form-control" formControlName="identification" [mask]="documentMask" [validation]="false">
                                </div>
                                <app-form-errors [controlName]="form.controls['identification']"></app-form-errors>
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Nombre</label>
                                <div>
                                    <input type="text" class="form-control" formControlName="firstName">
                                </div>
                                <app-form-errors [controlName]="form.controls['firstName']"></app-form-errors>
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label>Segundo nombre</label>
                                <div>
                                    <input type="text" class="form-control" formControlName="middleName">
                                </div>
                                <app-form-errors [controlName]="form.controls['middleName']"></app-form-errors>
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Apellido</label>
                                <div>
                                    <input type="text" class="form-control" formControlName="lastName">
                                </div>
                                <app-form-errors [controlName]="form.controls['lastName']"></app-form-errors>
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label>Segundo apellido</label>
                                <div>
                                    <input type="text" class="form-control" formControlName="secondLastName">
                                </div>
                                <app-form-errors [controlName]="form.controls['secondLastName']"></app-form-errors>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Fecha de nacimiento</label>
                                <div>
                                    <input type="date" class="form-control" formControlName="birthDate">
                                </div>
                                <app-form-errors [controlName]="form.controls['birthDate']"></app-form-errors>
                                <div *ngIf="form.get('birthDate')?.errors?.['minAge']" class="text-danger small mt-1">
                                    La edad mínima requerida es de {{minAge}} años
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Nacionalidad</label>
                                <div>
                                    <app-dropdown [options]="nationalityList" formControlName="nationalityId"></app-dropdown>
                                </div>
                                <app-form-errors [controlName]="form.controls['nationalityId']"></app-form-errors>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Sexo</label>
                                <div>
                                    <app-dropdown [options]="sexList" formControlName="sexId"></app-dropdown>
                                </div>
                                <app-form-errors [controlName]="form.controls['sexId']"></app-form-errors>
                            </div>
                        </div>
                    </div>
                    
                    <h5 class="mt-2 mb-2">Contraseña</h5>
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Contraseña</label>
                                <div>
                                    <input type="password" class="form-control" formControlName="password">
                                </div>
                                <app-form-errors [controlName]="form.controls['password']"></app-form-errors>
                                <!-- Requisitos de contraseñ -->
                                <div class="password-requirements mt-2" [ngClass]="{'text-danger': form.controls['password'].dirty && form.controls['password'].invalid}">
                                    <small>La contraseña debe cumplir los siguientes requisitos:</small>
                                    <ul class="small mt-1 ps-3">
                                        <li>Al menos 8 caracteres</li>
                                        <li>Al menos una letra mayúscula</li>
                                        <li>Al menos una letra minúscula</li>
                                        <li>Al menos un número</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Confirmar contraseña</label>
                                <div>
                                    <input type="password" class="form-control" formControlName="confirmPassword">
                                </div>
                                <div *ngIf="form.controls['password'].value !== form.controls['confirmPassword'].value && form.controls['confirmPassword'].dirty" class="text-danger mt-1 small">
                                    Las contraseñas no coinciden
                                </div>
                                <div *ngIf="form.controls['password'].value === form.controls['confirmPassword'].value && form.controls['confirmPassword'].value && form.controls['confirmPassword'].dirty" class="text-success mt-1 small">
                                    Las contraseñas coinciden
                                </div>
                                <app-form-errors [controlName]="form.controls['confirmPassword']"></app-form-errors>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Columna derecha con foto y documentos -->
                <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
                    <!-- SECCIÓN FOTO PRINCIPAL -->
                    <div class="card mb-3">
                        <div class="card-body text-center position-relative">
                            <h5 class="mb-2">Foto de perfil <span class="required-field"></span></h5>
                            <div class="photo-container mb-3 position-relative">
                                <img [src]="photoPreview || 'assets/Images/user.png'" alt="Foto de perfil" class="img-fluid rounded-circle" style="max-height: 200px; max-width: 200px;" />
                                <button *ngIf="photoPreview" type="button" class="btn btn-danger btn-sm position-absolute" style="position: absolute; top: 8px; right: 8px; z-index: 2; 
                                 border-radius: 50%; width: 32px; height: 32px;" (click)="removePhoto()">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                            <button type="button" class="btn btn-primary" (click)="uploadFoto()">
                                <i class="fa-solid fa-upload me-1"></i> Subir foto
                            </button>
                            <div class="d-none">
                                <input type="file" accept="image/*" id="fileFoto" (change)="onPhotoSelected($event)">
                            </div>
                            <small class="d-block text-muted mt-2">Formatos permitidos: JPG, PNG</small>
                        </div>
                    </div>
                    
                    <div class="card">
                        <div class="card-body">
                            <h5 class="mb-3">Documentos</h5>
                            <div class="document-item mb-3">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <span class="document-label">Documento de identidad</span>
                                    </div>
                                    <div>
                                        <button type="button" class="btn btn-sm btn-primary me-2" (click)="uploadIdentificationDoc()">
                                            <i class="fa-solid fa-upload me-1"></i> Subir
                                        </button>
                                        <a *ngIf="identificationDocPreview" [href]="identificationDocPreview" target="_blank" class="btn btn-sm btn-outline-primary">
                                            <i class="fa-solid fa-eye me-1"></i> Ver
                                        </a>
                                    </div>
                                </div>
                                <div *ngIf="identificationDocPreview && identificationDocPreview.toLowerCase().endsWith('.pdf')" class="preview-container mt-2 position-relative">
                                    <div class="pdf-preview">
                                        <i class="fa-solid fa-file-pdf fa-3x text-danger"></i>
                                        <span class="ms-2">Documento PDF</span>
                                        <button *ngIf="identificationDocPreview" type="button" class="btn btn-danger btn-sm position-absolute" style="top: 10px; right: 10px; border-radius: 50%; z-index: 2;" (click)="removeIdentificationDoc()">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="identificationDocPreview && !identificationDocPreview.toLowerCase().endsWith('.pdf')" class="preview-container mt-2 position-relative">
                                    <img [src]="identificationDocPreview" alt="Vista previa" class="img-fluid preview-img">
                                    <button *ngIf="identificationDocPreview" type="button" class="btn btn-danger btn-sm position-absolute" style="top: 10px; right: 10px; border-radius: 50%; z-index: 2;" (click)="removeIdentificationDoc()">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                            <small class="text-muted">Formatos permitidos: JPG, PNG, PDF</small>
                            <div class="d-none">
                                <input type="file" accept="image/*,application/pdf" id="fileDocReq" (change)="onIdentificationDocSelected($event)">
                            </div>
                        </div>
                    </div>
                    
                    <div class="small text-muted mt-2">
                        <i class="fa-solid fa-circle-info me-1"></i>
                        Los campos marcados con <span class="required-field"></span> son obligatorios.
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" class="btn btn-secondary me-2" (click)="closeDialog(false)" [disabled]="isSaving || isLoading">
        <i class="fa-solid fa-times me-1"></i> Cancelar
    </button>
    <button type="button" class="btn btn-primary" (click)="accept()" [disabled]="isSaving || isLoading || form.invalid">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i *ngIf="!isSaving" class="fa-solid fa-save me-1"></i>
        {{ isSaving ? 'Creando...' : 'Crear Administrador' }}
    </button>
</mat-dialog-actions>
